/** Ce que partagent les écrans Firmware : les droits, et les couleurs des états. */
export default {
  computed: {
    // Le module Firmware est réservé à ZEborne.
    isFirmwareOperator() {
      return !!this.currentUser?.rootOrganizationId
    },
    canReadFirmware() {
      return this.isFirmwareOperator && this.hasFirmwarePermission('FIRMWARE_READ')
    },
    canDeployFirmware() {
      return this.isFirmwareOperator && this.hasFirmwarePermission('FIRMWARE_DEPLOY')
    },
    canEditCatalogue() {
      return this.isFirmwareOperator && this.hasFirmwarePermission('FIRMWARE_CATALOGUE')
    },
    // Les constructeurs, leurs gammes et leurs réglages (notion de toute la plateforme, pas seulement firmware).
    canEditManufacturer() {
      return this.isFirmwareOperator && this.hasFirmwarePermission('MANUFACTURER_CATALOGUE')
    },
    canForceFirmware() {
      return this.isFirmwareOperator && this.hasFirmwarePermission('FIRMWARE_FORCE')
    },
  },

  methods: {
    hasFirmwarePermission(permission) {
      return (this.currentUser?.permissions || []).includes(permission)
    },

    // Où en est une borne : à jour, mise à jour disponible, sans chemin, pas de firmware au catalogue.
    adviceColor(state) {
      return {'up-to-date': 'success', 'update-available': 'primary', 'no-path': 'orange', 'not-covered': 'grey', 'pinned': 'deep-purple'}[state] || 'grey'
    },

    firmwareStatusColor(status) {
      return {draft: 'grey', testing: 'orange', validated: 'success', retired: 'blue-grey', blocked: 'error'}[status] || 'grey'
    },

    campaignStatusColor(status) {
      return {scheduled: 'blue-grey', running: 'primary', paused: 'orange', finished: 'success', cancelled: 'grey'}[status] || 'grey'
    },

    memberStateColor(state) {
      return {
        queued: 'blue-grey',
        running: 'primary',
        succeeded: 'success',
        failed: 'error',
        cancelled: 'grey',
        held: 'orange',
        excluded: 'grey lighten-1',
        skipped: 'grey darken-1',
      }[state] || 'grey'
    },
  },
}
